module.exports = {"120115001":"海滨街道","120115002":"宝平街道","120115003":"钰华街道","120115004":"大白街道","120115005":"口东街道","120115006":"周良街道","120115007":"潮阳街道","120115008":"朝霞街道","120115101":"大口屯镇","120115103":"王卜庄镇","120115104":"方家庄镇","120115105":"林亭口镇","120115106":"八门城镇","120115107":"大钟庄镇","120115108":"新安镇","120115111":"霍各庄镇","120115113":"新开口镇","120115115":"大唐庄镇","120115119":"牛道口镇","120115120":"史各庄镇","120115121":"郝各庄镇","120115123":"牛家牌镇","120115124":"尔王庄镇","120115125":"黄庄镇","120115453":"天宝工业园区","120115454":"九园工业园区","120115455":"京津新城","120115500":"里自沽农场","120115501":"黄庄农场","120115502":"大钟农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120115.json
// module id = 51
// module chunks = 0